<template>
  <div class="dashboard-container">
    <el-form label-width="96px">
      <el-form-item label="裁判" >
        <el-select v-model="referee.id" filterable placeholder="请选择" clearable @change="onRefereeChange">
          <el-option
            v-for="item in refereeList"
            :key="item.id"
            :label="item.trueName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="比赛监督" >
        <el-input v-model="referee.type8" type="number" :disabled="selectReferee.inField==1"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="主裁1" >
            <el-input v-model="referee.type01" type="number" :disabled="selectReferee.inField==0"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="主裁2" >
            <el-input v-model="referee.type02" type="number" :readonly="true" :disabled="selectReferee.inField==0"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="边裁1" >
            <el-input v-model="referee.type11" type="number" :disabled="selectReferee.inField==0"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="边裁2" >
            <el-input v-model="referee.type12" type="number" :disabled="selectReferee.inField==0"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="裁判监督" >
            <el-input v-model="referee.type2" type="number" :disabled="selectReferee.inField==0"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="计时" >
            <el-input v-model="referee.type3" type="number" :disabled="selectReferee.inField==1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="记录" >
            <el-input v-model="referee.type4" type="number" :disabled="selectReferee.inField==1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="宣告" >
            <el-input v-model="referee.type5" type="number" :disabled="selectReferee.inField==1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="记罚1" >
            <el-input v-model="referee.type61" type="number" :disabled="selectReferee.inField==1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="助理1" >
            <el-input v-model="referee.type71" type="number" :disabled="selectReferee.inField==1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="助理2" >
            <el-input v-model="referee.type72" type="number" :disabled="selectReferee.inField==1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="助理3" >
            <el-input v-model="referee.type73" type="number" :disabled="selectReferee.inField==1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="记罚2" >
            <el-input v-model="referee.type62" type="number" :disabled="selectReferee.inField==1"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="refereeActionSave()" :loading="useLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {adminGetRefereeList} from '@/api/referee'
  import {adminAddRefereeOutGameOffices, adminGetRefereeOutGameOffices} from '@/api/match'
  import {showMessage} from "@/utils";

  export default {
  name: 'BatchUpdateDetail',
  data() {
    return {
      useLoading:false,
      matchId: null,
      routerParams: {},
      refereeList: [],
      referee:{},
      selectReferee: {
        inField: 99
      }
    }
  },
  created() {
    this.matchId = this.$route.params.id
    this.getRefereeList()
  },
  computed: {
  },
  methods: {
    getRefereeList() {
      const params = {
        pageNum: 1,
        pageSize: 9999
      }
      adminGetRefereeList(params).then((resolve) => {
        this.refereeList = resolve.data.list
      })
    },
    onRefereeChange() {
      this.selectReferee = this.refereeList.find(item => item.id === this.referee.id)
      if(this.referee.id) {
        const param = {
          refereeId: this.referee.id,
          matchId: this.matchId
        }
        adminGetRefereeOutGameOffices(param).then(response => {
          const data = response.data
          if (data) {
            this.referee = data.referee
          }
        })
      }
    },
    refereeActionSave() {
      this.useLoading = true
      const params = {
        refereeId: this.referee.id,
        matchId: this.matchId,
        type01:this.referee.type01,
        type02:this.referee.type02,
        type11:this.referee.type11,
        type12:this.referee.type12,
        type2:this.referee.type2,
        type3:this.referee.type3,
        type4:this.referee.type4,
        type5:this.referee.type5,
        type61:this.referee.type61,
        type62:this.referee.type62,
        type71:this.referee.type71,
        type72:this.referee.type72,
        type73:this.referee.type73,
        type8:this.referee.type8,
      }

      adminAddRefereeOutGameOffices(params).then(response=>{
        const data = response.data
        if(data) {
          showMessage("success", "保存成功")
        }
        this.useLoading = false
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
